<template>
  <div class="edit-op-container">
    <sweet-modal ref="modal" hideCloseButton @close="$emit('close')">
      <div class="content">
        <admin-form-item label="품목명">
          <input class="input-border" type="text" v-model="value.name" @input="e => value.name = e.target.value.toUpperCase()">
        </admin-form-item>
        <admin-form-item label="단가(유로)">
          <input class="input-border" type="text" v-model="value.price" @input="e => value.price = e.target.value">
        </admin-form-item>
        <admin-form-item label="품목 수">
          <input class="input-border" type="text" v-model="value.quantity" @input="e => value.quantity = e.target.value">
        </admin-form-item>
        <admin-form-item label="합계(유로)">
          <input class="input-border" type="text" v-model="value.total_price" readonly>
        </admin-form-item>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$refs.modal.close()">취소</button>
          <button class="button is-primary" @click="accept">확인</button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  export default {
    name: "EditOrderProduct",
    components: {
      SweetModal
    },
    props: {
      infoId: {
        type: Number
      },
      product: {
        type: Object
      }
    },
    created() {
      this.value = this.cloneItem(this.product);
    },
    mounted() {
      this.$nextTick(()=>{
        this.$refs.modal.open();
      });
    },
    data() {
      return {
        value: undefined
      }
    },
    methods: {
      accept() {
        const resMethod = () => {
          this.$emit('save', this.value);
          this.$refs.modal.close();
        };
        if(this.value.id === 0) {
          this.$axios.post(`admin/shipagency/base_info/${this.infoId}/product`, this.value).then(resMethod);
        } else {
          this.$axios.patch(`admin/shipagency/base_info/product/${this.value.id}`, this.value).then(resMethod);
        }
      }
    },
    watch: {
      value: {
        handler() {
          this.value.total_price = this.value.price * this.value.quantity;
        },
        deep: true
      }
    }
  }
</script>

<style lang="stylus">
  .edit-op-container
    .sweet-modal
      width 500px
    .sweet-modal.is-alert .sweet-content
      padding 20px
</style>
